<!--
 * @Author: DQL
 * @Date: 2020-03-12 14:56:00
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-29 14:37:24
 * @Description: 左右两列布局
 -->
<template>
  <el-row
    type="flex"
    class="l-page l-page--nav"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :md="8"
      :span="10"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            岗位分类
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <el-tree
                  class="c-asideTree__tree o-tree-overflow--unset"
                  highlight-current
                  :data="roleTypeList"
                  :props="defaultProps"
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
            <!-- 树导航 End -->
          </hm-page-card>
        </div>
        <!-- 左侧导航主内容 End -->
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :md="16"
      :span="14"
    >
      <!-- 右侧内容：查询类布局 Start -->
      <div
        class="l-page--inner l-page--search"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header c-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            岗位维护
          </h2>

          <!-- 标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              v-permission-admin-element
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch"
            >
              查询
            </el-button>
            <el-button
              v-permission-admin-element
              icon="kestrel-icon ki-repeat"
              @click="resetForm"
            >
              重置
            </el-button>
            <el-button
              v-permission-admin-element
              type="success"
              icon="kestrel-icon ki-plus"
              @click="handleAdd"
            >
              新增
            </el-button>
            <el-button
              v-permission-admin-element
              type="success"
              plain
              icon="kestrel-icon ki-edit"
              :disabled="selectedRow.roleCode===null"
              @click="handleUpdate"
            >
              修改
            </el-button>
            <el-button
              v-permission-admin-element
              type="danger"
              icon="kestrel-icon ki-trash"
              :disabled="selectedRow.roleCode===null"
              @click="handleDel"
            >
              删除
            </el-button>
            <el-button
              v-permission-admin-element
              type="primary"
              plain
              icon="kestrel-icon ki-link"
              :disabled="selectedRow.roleCode===null"
              @click="handleClickDeptRole"
            >
              关联组织
            </el-button>
            <el-button
              v-permission-admin-element
              type="primary"
              plain
              icon="kestrel-icon ki-gear"
              :disabled="selectedRow.roleCode===null"
              @click="handleClickMenuRole"
            >
              岗位菜单维护
            </el-button>
          </div>
          <!-- 标题栏按钮区域 End -->
        </div>
        <!-- 页面头部 End -->

        <!-- 查询条件 Start -->
        <div
          class="l-page__item l-page--search__item"
        >
          <hm-page-card
            title="查询条件"
            class="c-card--condition"
          >
            <!-- 查询条件表单 Start -->
            <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
            <el-form
              ref="filterParams"
              class="c-form c-condition__form"
              :inline="true"
              label-width="80px"
              label-suffix="："
              :model="filterParams"
            >
              <el-row
                class="c-form__row"
              >
                <el-col
                  class="c-form__col"
                  :span="12"
                >
                  <el-form-item
                    class="c-form__item"
                    label="岗位代码"
                    prop="roleCode"
                  >
                    <el-input
                      v-model.trim="filterParams.roleCode"
                      class="c-form__input"
                      placeholder="岗位代码"
                      clearable
                      maxlength="100"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  class="c-form__col"
                  :span="12"
                >
                  <el-form-item
                    class="c-form__item"
                    label="岗位名称"
                    prop="roleName"
                  >
                    <el-input
                      v-model.trim="filterParams.roleName"
                      class="c-form__input"
                      placeholder="岗位名称"
                      clearable
                      maxlength="100"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- 查询条件表单 End -->
          </hm-page-card>
        </div>
        <!-- 查询条件 End -->

        <!-- 页面主内容：查询列表 Start -->
        <div
          class="l-page__body l-page--search__body"
        >
          <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
          <el-tabs
            type="border-card"
            class="l-page__tabs l-page__tabs--single"
          >
            <el-tab-pane
              label="岗位列表"
            >
              <div
                class="c-page__pTable"
              >
                <!-- table的ref的命名根据业务名称修改 -->
                <el-table
                  ref="listTable"
                  v-loading="loading"
                  class="c-page__table o-header-text-center"
                  height="100%"
                  stripe
                  border
                  highlight-current-row
                  tooltip-effect="dark"
                  :data="page.rows"
                  :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
                  @row-click="handleRowClick"
                >
                  <el-table-column
                    class-name="c-table-column--selection"
                    width="30"
                  >
                    <template
                      slot-scope="scope"
                    >
                      <el-radio
                        v-model="selectedRow.roleCode"
                        :label="scope.row.roleCode"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    type="index"
                    label="序号"
                    width="40"
                    align="center"
                  />
                  <el-table-column
                    prop="roleCode"
                    label="岗位代码"
                    width="160"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="roleName"
                    label="岗位名称"
                    width="180"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="roleDescription"
                    label="岗位职责"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="securityName"
                    label="安全控制类别"
                    show-overflow-tooltip
                  />
                </el-table>
                <el-pagination
                  class="c-page__pagination"
                  :disabled="page.total<=0 || loading"
                  :page-size="page.pageSize"
                  :total="page.total"
                  :current-page="page.pageNo"
                  layout="total, sizes, prev, pager, next, jumper"
                  :page-sizes="[15,20,30]"
                  @current-change="search"
                  @size-change="handleSizeChange"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 页面主内容：查询列表 End -->
      </div>
    </el-col>
    <!-- 右侧主面板模块 End -->

    <!-- 修改岗位弹窗 -->
    <update-dialog
      v-if="showDialogName == 'update'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
    />

    <!-- 新增岗位弹窗 -->
    <update-dialog
      v-if="showDialogName == 'add'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
    />

    <!--  关联部门弹窗 -->
    <role-dept-relationship-dialog
      v-if="showDialogName == 'deptRole'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
    />

    <!--  岗位菜单维护弹窗 -->
    <role-menu-relationship-dialog
      v-if="showDialogName == 'menuRole'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
    />
  </el-row>
</template>

<script>
import UpdateDialog from './update.vue';
import RoleDeptRelationshipDialog from './roleDeptRelationship.vue';
import RoleMenuRelationshipDialog from './roleMenuRelationship.vue';
import { roleService, queryRoleType } from '@/features/system/role/role.service.js';
export default {
  name: 'RoleList', // 岗位维护
  components: { UpdateDialog, RoleDeptRelationshipDialog, RoleMenuRelationshipDialog },
  data () {
    return {
      loading: false, // 页面loading状态

      /* 树组件配置 start */
      roleTypeList: [], // 树组件具体数据
      // 树组件默认参数配置
      defaultProps: {
        label: 'roleTypeName',
        children: 'childrens'
      },
      /* 树组件配置 end */

      currentRoleType: { // 当前被选中的岗位分类
        roleTypeName: '',
        roleTypeDm: '',
        roleType: '',
        roleTypeNameValue: ''
      },

      /*  查询条件 Start */
      filterParams: {
        roleTypeDm: '', // 岗位分类代码
        roleCode: '',
        roleName: ''
      },
      /*  查询条件 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      selectedRow: { // 表格选中行（单选）
        roleCode: null
      },

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */
    };
  },
  methods: {
    /* 初始化部分 */
    /**
     * @description: 读取岗位分类
     * @param {*}
     * @return {*}
     */
    getRoleType () {
      this.loading = true;
      queryRoleType()
        .then((resp) => {
          this.roleTypeList = resp.data;
        })
        .catch(err => {
          console.error('读取岗位分类出错', err);
        })
        .finally(() => {
          this.loading = false;
        }); ;
    },
    /**
     * @description: 岗位分类点击节点时，重置查询条件并重新查询。
     * @param {Object} node 返回的数据节点
     * @return {*}
     */
    handleNodeClick (node) {
      this.currentRoleType.roleTypeName = node.roleTypeName; // 岗位分类
      this.currentRoleType.roleTypeDm = node.roleTypeDm;
      this.currentRoleType.roleType = node.roleType; // 岗位类型
      this.currentRoleType.roleTypeNameValue = node.roleTypeNameValue;
      this.resetForm();
      this.refreshSearch();
    },
    /**
     * @description: 是否选择了岗位分类
     * @param {*}
     * @return {*}
     */
    isCurrentRoleTypeDmExist () {
      return this.currentRoleType.roleTypeDm === '';
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @param {*}
     * @return {*}
     */
    refreshSearch () {
      if (this.isCurrentRoleTypeDmExist()) {
        this.$alert('请选择岗位分类！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      // 读取当前岗位分类代码，用于查询
      this.trueFilterParams.roleTypeDm = this.currentRoleType.roleTypeDm;

      this.loading = true;

      roleService.queryRole(this.trueFilterParams)
        .then(rsp => {
          this.page = rsp.data;
          // 移除单选按钮选中效果
          this.selectedRow.roleCode = null;
        })
        .catch(err => {
          console.error('查询岗位出错', err);
        })
        .finally(() => {
          this.loading = false;
        }); ;
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置表单
     * @param {*}
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 表格选中行事件（单选）
     * @param {Object} row
     * @param {Object} column
     * @param {any} event
     * @return {*}
     */
    handleRowClick (row, column, event) {
      this.selectedRow = row;
    },
    /**
     * @description: 新增岗位
     * @param {*}
     * @return {*}
     */
    handleAdd () {
      if (this.isCurrentRoleTypeDmExist()) {
        this.$alert('请选择岗位分类！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
      } else {
        this.handleDialog('add', {
          roleTypeDm: this.currentRoleType.roleTypeDm, // 岗位分类
          roleTypeName: this.currentRoleType.roleTypeName,
          roleType: this.currentRoleType.roleType, // 岗位类型
          roleTypeNameValue: this.currentRoleType.roleTypeNameValue
        });
      }
    },
    /**
     * @description: 更新岗位
     * @param {*}
     * @return {*}
     */
    handleUpdate () {
      if (this.isCurrentRoleTypeDmExist()) {
        this.$alert('请选择岗位分类！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
      } else {
        // 已选择某一行且是手工
        if (this.selectedRow && (this.selectedRow.sourceTypeCode === '0' || this.selectedRow.sourceTypeCode === 0 || this.selectedRow.sourceTypeCode === null)) {
          this.handleDialog('update', {
            roleTypeDm: this.currentRoleType.roleTypeDm, // 岗位分类
            roleTypeName: this.currentRoleType.roleTypeName,
            roleType: this.currentRoleType.roleType, // 岗位类型
            roleTypeNameValue: this.currentRoleType.roleTypeNameValue,
            roleCode: this.selectedRow.roleCode
          });
        } else if (this.selectedRow.sourceTypeCode === '1' || this.selectedRow.sourceTypeCode === 1) {
          this.$alert('该岗位是同步的岗位不允许修改！', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          });
        } else {
          this.$alert('请选择具体的行！', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          });
        }
      }
    },
    /**
     * @description: 删除岗位
     * @param {*}
     * @return {*}
     */
    handleDel () {
      const _this = this;
      if (_this.isCurrentRoleTypeDmExist()) {
        _this.$alert('请选择岗位分类！', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
      } else {
        if (_this.selectedRow && (_this.selectedRow.sourceTypeCode === '0' || _this.selectedRow.sourceTypeCode === 0 || _this.selectedRow.sourceTypeCode === null)) {
          _this.$confirm('确认要删除此岗位吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            roleService.deleteRole(_this.selectedRow.roleCode)
              .then(rsp => {
                _this.$alert('删除岗位成功！', '提示', {
                  confirmButtonText: '确定',
                  type: 'success'
                });
                _this.refreshSearch();
              }).catch(err => {
                console.error('删除岗位出错！', err);
              }).finally(() => {
                _this.loading = false;
              }); ;
          });
        } else if (_this.selectedRow.sourceTypeCode === '1' || _this.selectedRow.sourceTypeCode === 1) {
          _this.$alert('该岗位是同步的岗位不允许删除！', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          });
        } else {
          _this.$alert('请选择具体的行！', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          });
        }
      }
    },
    /**
     * @description: 关联部门
     * @param {*}
     * @return {*}
     */
    handleClickDeptRole () {
      if (this.selectedRow) {
        this.handleDialog('deptRole', {
          roleCode: this.selectedRow.roleCode,
          roleName: this.selectedRow.roleName
        });
      } else {
        this.$alert('请选择具体的行！', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
      }
    },
    /**
     * @description: 岗位菜单功能维护
     * @param {*}
     * @return {*}
     */
    handleClickMenuRole () {
      if (this.selectedRow) {
        this.handleDialog('menuRole', {
          roleCode: this.selectedRow.roleCode,
          roleName: this.selectedRow.roleName,
          securityType: this.selectedRow.securityType,
          securityName: this.selectedRow.securityName
        });
      } else {
        this.$alert('请选择具体的行！', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
      }
    },
    /**
     * @description: 岗位菜单功能维护
     * @param {*}
     * @return {*}
     */
    handleClickAppRole () {
      if (this.selectedRow) {
        this.handleDialog('appRole', {
          roleCode: this.selectedRow.roleCode,
          roleName: this.selectedRow.roleName,
          securityType: this.selectedRow.securityType,
          securityName: this.selectedRow.securityName
        });
      } else {
        this.$alert('请选择具体的行！', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
      }
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    }
  },
  mounted () {
    this.getRoleType();
  }
};
</script>
